module.exports = __webpack_public_path__ + "img/print-24px.375ad447.svg";